import React from 'react';
import {View} from 'react-native';
import {observer} from 'mobx-react-lite';

import {useResolvedPricing} from '../../../hooks/pricing';
import {toAUD} from '../../../utils/functions';
import Text from '../../ui-controls/Text';
import {pricingStyles as styles} from '../styles';
import {ProductTilePricingProps} from '../types';

import MembersPriceLabel from './MembersPriceLabel';
import SecondaryCalloutLabel from './SecondaryCalloutLabel';

const ProductTilePricing = observer(function ProductTilePricing({
  item,
  showMemberLabel = true,
  showOriginalPrice = true,
  showNonMemberPrice = true,
  priceStyle,
  containerStyle,
  testID,
}: ProductTilePricingProps) {
  const pricing = useResolvedPricing(item, 'marketing');

  return (
    <View style={[styles.container, containerStyle]} testID={testID}>
      {showMemberLabel ? (
        <MembersPriceLabel
          showLabel={pricing.advertiseMemberPrice}
          labelText={pricing.memberLabelText}
        />
      ) : null}

      {showNonMemberPrice ? <SecondaryCalloutLabel item={item} /> : null}

      <View style={styles.priceRow}>
        <Text style={[styles.price, priceStyle]} testID={testID ? `${testID}-price` : undefined}>
          {toAUD(pricing.displayPrice)}
        </Text>
        <Text style={styles.priceUnit} numberOfLines={1}>
          each
        </Text>
      </View>

      {showOriginalPrice && !showNonMemberPrice && pricing.isOnSale ? (
        <View style={styles.originalPriceRow}>
          <Text style={styles.wasText}>was </Text>
          <Text style={styles.originalPrice}>{toAUD(pricing.wasPrice!)}</Text>
        </View>
      ) : null}
    </View>
  );
});

export default ProductTilePricing;
